import React from 'react';
import { useSyncStatus } from '../hooks/useSyncStatus';

const SyncIndicator: React.FC = () => {
  const { status, pendingCount } = useSyncStatus();

  if (status === 'idle') return null;

  let content = null;
  let className = 'badge rounded-pill d-flex align-items-center gap-1 ';

  switch (status) {
    case 'syncing':
      className += 'bg-info text-dark';
      content = (
        <>
          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ width: '0.7rem', height: '0.7rem' }}></span>
          <span>Syncing ({pendingCount})</span>
        </>
      );
      break;
    case 'offline':
      className += 'bg-secondary';
      content = (
        <>
          <span>Offline ({pendingCount})</span>
        </>
      );
      break;
    case 'error':
      className += 'bg-danger';
      content = (
        <>
          <span>Sync Error ({pendingCount})</span>
        </>
      );
      break;
  }

  return (
    <div className="nav-item d-flex align-items-center me-2">
      <div className={className} title="Data synchronization status">
        {content}
      </div>
    </div>
  );
};

export default SyncIndicator;
